import React, { useState, forwardRef, useEffect } from "react";
import Upload from "../../../Assets/Image/png/upload.png";
const DragandDropWithoutbtn = forwardRef((props, ref) => {
    const {
        value,
        isSubmitted,
        message,
        defValue,
        error,
        label,
        id,
        icon,
        type,
        close,
        setFile,
        bootcamp_cover,
        ...rest
    } = props;
    const [createObjectURL, setCreateObjectURL] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [uploaded, setUploaded] = useState(false);
    const handleChange = ({ target }) => {
        if (target.files) {
            props.setFile(target.files);
            console.log("first", target?.files);
            const reader = new FileReader();
            reader.addEventListener("load", () => {
                setCreateObjectURL(reader.result);
            });
            reader.readAsDataURL(target.files[0]);
            setFileName(target?.files[0]?.name);
        }
    };
    useEffect(() => {
        if (isSubmitted) {
            setFileName("");
        }
    }, [isSubmitted]);

    useEffect(() => {
        if (props.sessionInfo === false) {
            setFileName("");
            setCreateObjectURL("");
        }
    }, [props.sessionInfo]);
    //TODO : inja momkene baghie jaha bug beshe

    console.log(createObjectURL);

    return (
        <div className="text-center">
            {uploaded ? (
                <div className=" text-right text-[#212121E5] text-[1.8rem] font-normal leading-[3.2rem]">
                    {fileName}
                </div>
            ) : (
                <>
                    {" "}
                    <div className=" text-right text-[#212121E5] text-[1.8rem] font-normal leading-[3.2rem]">
                        {fileName}
                    </div>
                    <div
                        onDrag={handleChange}
                        className="border-purple border-dashed border-[1px] rounded-3xl  text-center text-[1.8rem] flex justify-center flex-col items-center cursor-pointer relative"
                    >
                        <input
                            ref={ref}
                            type="file"
                            onInput={handleChange}
                            className=" w-full h-full absolute opacity-0"
                            {...rest}
                            id={id}
                        />
                        <div className=" py-24 px-[21rem] text-center flex justify-center flex-col items-center cursor-pointer">
                            {type === "image" &&
                            (createObjectURL || bootcamp_cover) ? (
                                <img
                                    className=" max-w-[30.7rem] max-h-[20.5rem]"
                                    src={createObjectURL || bootcamp_cover}
                                    alt="Card cap"
                                />
                            ) : (
                                <>
                                    {" "}
                                    <img
                                        src={Upload}
                                        className=" mb-14"
                                        alt="Upload"
                                    />
                                    <p>
                                        فایل مورد نظر خود را بکشید و اینجا رها
                                        کنید.
                                    </p>
                                    <p>
                                        یا در کامپیوتر خود{" "}
                                        <span className=" text-[#9C5FA4]">
                                            {" "}
                                            جستجو
                                        </span>{" "}
                                        کنید
                                    </p>
                                </>
                            )}
                        </div>
                    </div>
                    {error && (
                        <span className="input__message text-[1.4rem] text-red-500">
                            {message}
                        </span>
                    )}{" "}
                </>
            )}
        </div>
    );
});

export default DragandDropWithoutbtn;
